import React from "react";

import Sidebar from "components/sidebar/Sidebar.js";

import {
  Box,
  useColorModeValue,
  Portal,
  useDisclosure,
  SimpleGrid,
} from "@chakra-ui/react";
import { Table, Tbody, Th, Thead, Tr, Input, Td } from "@chakra-ui/react";

import { useMemo, useState, useEffect } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Navbar from "components/navbar/NavbarAdmin.js";
import MiniStatistics from "components/card/MiniStatistics";
import { MdBarChart } from "react-icons/md";
import ModalAllPages from "components/pdf/ModalAllPages";
// import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { SidebarContext } from "contexts/SidebarContext";
// Custom components
import Card from "components/card/Card";
// Custom components

import { fetchList } from "api/function";
import { addFunction } from "api/function";
import Loader from "components/Loader";
import routes from "routes.js";

import ResizableTable from "components/ResizableTable";

import IconBox from "components/icons/IconBox";

import { Flex, Checkbox, Text, Icon, Button } from "@chakra-ui/react";
import Menu from "components/menu/MainMenu";
import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";
import { fileCLaimsExist } from "helper/UploadFilePageHelper";
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";

import ReportModal from "components/reportModal";
import BigQueryModal from "components/bigQueryModal";

import { useSelector } from "react-redux";
import {
  selectUploadFileModuleData,
  selectUploadFileModuleFiles,
} from "redux/selectorFunctions";

// const api_url = process.env.REACT_APP_API;

export default function Marketplace(props) {
  const navigate = useNavigate();

  const selectUploadFileModuleDataRedux = useSelector(
    selectUploadFileModuleData
  );

  const selectUploadFileModuleFileRedux = useSelector(
    selectUploadFileModuleFiles
  );
  const { onOpen } = useDisclosure();

  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columnNames, setcolumnNames] = useState([]);
  const [reportPreview, setReportPreview] = useState(null);
  const [showreportPreview, setShowreportPreview] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const [ContractFiles, setContractFiles] = useState([]);
  const [claimPreviewFile, setCLiamreviewFile] = useState([]);

  const [electronicClaim, setElectronicClaim] = useState(null);
  const [chnageTofile, setChangeToFile] = useState(false);

  const [datasets, setDatasets] = useState([]);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [modalLoading, setModalLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [bigQuerySuccessAlert, setBigQuerySuccessAlert] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [tables, setTables] = useState([]);

  useEffect(() => {
    if (location.state === null) {
      navigate("/claim");
    } else {
      // Force loader ON for 5 seconds
      setLoading(true);

      const table_data = location.state.data;

      const timer = setTimeout(() => {
        setTableData(table_data);

        if (table_data && table_data.length > 0) {
          setcolumnNames(Object.keys(table_data[0]));
        } else {
          setcolumnNames([]);
        }

        setLoading(false);
      }, 5000);

      return () => clearTimeout(timer); // cleanup on unmount
    }
  }, []);

  function checkSuccess(data) {
    const report = data.report;
    if (!report) {
      return true;
    }
    // "border-2 border-[#FF5733]"
    for (const key in report) {
      if (
        report.hasOwnProperty(key) &&
        typeof report[key] === "object" &&
        "match" in report[key]
      ) {
        if (!report[key].match) {
          return false;
        }
      }
    }

    return true;
    // "border-2 border-[#7CFC00]"
  }

  async function fetchFileContent(cpt_code, file_data) {
    setElectronicClaim(file_data);

    setCLiamreviewFile(null);
    setShowPreview(false);
  }

  async function fetchContractFIleContent(tax_id) {
    setContractFiles(null);
    setShowPreview(false);
  }
  function handleObject(value) {
    if (typeof value === "string") {
      return value;
    } else if (value instanceof Array) {
      return value.join(", ");
    } else if (value instanceof Array) {
    } else if (value instanceof Object) {
      return Object.entries(value).map(([key, value]) => (
        <tr key={key}>
          <Td className="border px-4 py-2">{key}</Td>
          <Td className="border px-4 py-2">{handleObject(value)}</Td>
        </tr>
      ));
    } else {
    }
  }

  function convertString(str) {
    // Replace underscores with spaces
    const replacedStr = str.replace(/_/g, " ");

    // Convert to uppercase
    const uppercasedStr = replacedStr.toUpperCase();

    return uppercasedStr;
  }

  function beutifyData(data) {
    const keysToKeep = [
      "CPT_CODE",
      "DESCRIPTION",
      "Date of Service",
      "Provider_Name",
      "TAX_ID",
      "Place_of_Service",
      "Date_of_Service",
      "report",
    ];
    const newTableData = [];
    tableData.map((obj) => {
      const newObj = {};
      keysToKeep.forEach((key) => {
        newObj[key] = obj[key];
      });
      newTableData.push(newObj);
    });

    const newData = newTableData.map((obj) => {
      const { report } = obj;
      if (report !== null) {
        const matchValues = Object.values(report).map((item) => item.match);
        const hasFalseMatch = matchValues.includes(false);

        if (hasFalseMatch) {
          return {
            ...obj,
            report, // keep original
            reportStatus: hasFalseMatch ? "false" : "true", // new field
          };
        }

        return { ...obj, report: "true" };
      } else {
        return { ...obj, report: "null" };
      }
    });
    return newData;
  }

  const handleDownloadFileClick = async () => {
    const newData = beutifyData(tableData);
    // Demo: disable download in offline mode
  };
  const handleBigQueryClick = async () => {
    setOpenModal(true);
    // Demo: skip BigQuery dataset loading
    setDatasets([]);
    setModalLoading(false);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const data = beutifyData(tableData);
    setModalLoading(true);
    // Demo: skip BigQuery write
    setOpenModal(false);
  };

  function checkHowMuchExceding(contract_date, submit_claim_time, claim_date) {
    const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day

    // Convert the date strings to Date objects
    const contractDateObj = new Date(contract_date);
    const claimDateObj = new Date(claim_date);

    // Calculate the difference in days
    var diffDays = Math.floor(
      (claimDateObj.getTime() - contractDateObj.getTime()) / oneDay
    );
    if (diffDays > parseInt(submit_claim_time)) {
      return `Exceeded ${diffDays - parseInt(submit_claim_time)} days`; // Return the number of days exceeding the limit
    } else {
      return "On Time"; // Return 0 if the difference is within the limit
    }
  }

  const columnHeaders = columnNames.map((columnName) => {
    if (
      columnName === "CPT_CODE" ||
      columnName === "Provider_Name" ||
      columnName === "Date" ||
      columnName === "DESCRIPTION" ||
      columnName === "RATE" ||
      columnName === "TAX_ID" ||
      columnName === "report"
    ) {
      return convertString(columnName);
    } else {
      return "";
    }
  });

  // ----------------------------

  // Function to find matching report data based on claim details
  const findMatchingReport = (claimData) => {
    return (
      dummyReports.find(
        (report) =>
          report.CPT_CODE === claimData.CPT_CODE &&
          report.Provider_Name === claimData.Provider_Name &&
          report.TAX_ID === claimData.TAX_ID &&
          report.RATE === claimData.RATE
      ) || dummyReports[0]
    ); // fallback to first report if no match found
  };

  const dummyReports = [
    {
      Provider_Name: "SARAH WILLIAMS",
      DESCRIPTION: "Transection or avulsion of; supraorbital nerve",
      TAX_ID: "666543210",
      CPT_CODE: "64732", // ✅ Matches demoClaims
      RATE: "$120", // ✅ Matches demoClaims
      report: {
        provider_name: {
          claim_provider_name: "SARAH WILLIAMS",
          contract_provider_name: "SARAH WILLIAMS",
          match: true,
        },
        rate: {
          claim_rate: "$120",
          contract_rate: "$120",
          match: true,
        },
        submit_claim_date: {
          contract_date: "2025-08-01",
          claim_date: "2025-08-10",
          submit_claim_time: "45",
          match: true,
        },
      },
    },
    {
      Provider_Name: "SARAH WILLIAMS",
      DESCRIPTION: "Removal of bivalving; full arm or full leg cast",
      TAX_ID: "666543210",
      CPT_CODE: "29705", // ✅ Matches demoClaims
      RATE: "$95", // ✅ Matches demoClaims
      report: {
        provider_name: {
          claim_provider_name: "SARAH WILLIAMS",
          contract_provider_name: "SARAH WILLIAMS",
          match: true,
        },
        rate: {
          claim_rate: "$95",
          contract_rate: "$95",
          match: true,
        },
        submit_claim_date: {
          contract_date: "2024-08-01",
          claim_date: "2024-10-12",
          submit_claim_time: "45",
          match: false,
        },
      },
    },
    {
      Provider_Name: "SARAH WILLIAMS",
      DESCRIPTION:
        "Excision tumor, soft tissue of thigh or knee area, subcutaneous; less than 3 cm",
      TAX_ID: "666543210",
      CPT_CODE: "27327", // ✅ Matches demoClaims
      RATE: "$110", // ✅ Matches demoClaims
      report: {
        provider_name: {
          claim_provider_name: "SARAH WILLIAMS",
          contract_provider_name: "SARAH WILLIAMS",
          match: true,
        },
        rate: {
          claim_rate: "$110",
          contract_rate: "$110",
          match: true,
        },
        submit_claim_date: {
          contract_date: "2025-08-01",
          claim_date: "2025-08-10",
          submit_claim_time: "45",
          match: true,
        },
      },
    },
    {
      Provider_Name: "SARAH WILLIAMS",
      DESCRIPTION: "Removal of foreign body in muscle or tendon sheath; simple",
      TAX_ID: "666543210", // ✅ Updated (was 654321098)
      CPT_CODE: "20520", // ✅ Updated (was 97001)
      RATE: "$75", // ✅ Updated (was $130)
      report: {
        provider_name: {
          claim_provider_name: "SARAH WILLIAMS",
          contract_provider_name: "SARAH WILLIAMS",
          match: true,
        },
        rate: {
          claim_rate: "$75",
          contract_rate: "$75",
          match: true,
        },
        submit_claim_date: {
          contract_date: "2025-08-01",
          claim_date: "2025-08-18",
          submit_claim_time: "45",
          match: true,
        },
      },
    },
    {
      Provider_Name: "SOPHIA HARRIS",
      DESCRIPTION: "Transection or avulsion of; supraorbital nerve",
      TAX_ID: "654321098",
      CPT_CODE: "97001", // ✅ Updated (was 97003)
      RATE: "$130", // ✅ Updated (was $90)
      report: {
        provider_name: {
          claim_provider_name: "SOPHIAA HARRIS",
          contract_provider_name: "SOPHIA HARRIS",
          match: false,
        },
        rate: {
          claim_rate: "$130",
          contract_rate: "$130",
          match: true,
        },
        submit_claim_date: {
          contract_date: "2025-08-01",
          claim_date: "2025-08-20",
          submit_claim_time: "110",
          match: true,
        },
      },
    },
    {
      Provider_Name: "SOPHIA HARRIS",
      DESCRIPTION: "Removal or bivalving; full arm or full leg cast",
      TAX_ID: "654321098",
      CPT_CODE: "97003", // ✅ Updated (was 97110)
      RATE: "$90", // ✅ Updated (was $115)
      report: {
        provider_name: {
          claim_provider_name: "SOPHIA HARRIS",
          contract_provider_name: "SOPHIA HARRIS",
          match: true,
        },
        rate: {
          claim_rate: "$90",
          contract_rate: "$90",
          match: true,
        },
        submit_claim_date: {
          contract_date: "2025-08-01",
          claim_date: "2025-08-19",
          submit_claim_time: "110",
          match: true,
        },
      },
    },
    {
      Provider_Name: "SOPHIA HARRIS",
      DESCRIPTION:
        "Excision tumor, soft tissue of thigh or knee area, subcutaneous; less than 3 cm",
      TAX_ID: "654321098", // ✅ Updated (was 666543210)
      CPT_CODE: "97012", // ✅ Updated (was 20520)
      RATE: "$105", // ✅ Updated (was $75)
      report: {
        provider_name: {
          claim_provider_name: "SOPHIA HARRIS",
          contract_provider_name: "SOPHIA HARRIS",
          match: true,
        },
        rate: {
          claim_rate: "$105",
          contract_rate: "$105",
          match: true,
        },
        submit_claim_date: {
          contract_date: "2019-08-15",
          claim_date: "2020-08-01",
          submit_claim_time: "110",
          match: false,
        },
      },
    },
    {
      Provider_Name: "SOPHIA HARRIS",
      DESCRIPTION:
        "Application of a modality to one or more areas; electrical stimulation (unattended)",
      TAX_ID: "654321098", // ✅ Updated (was 666543210)
      CPT_CODE: "97110", // ✅ Updated (was 20520)
      RATE: "$115", // ✅ Updated (was $75)
      report: {
        provider_name: {
          claim_provider_name: "SOPHIA HARRIS",
          contract_provider_name: "SOPHIA HARRIS",
          match: true,
        },
        rate: {
          claim_rate: "$415",
          contract_rate: "$115",
          match: false,
        },
        submit_claim_date: {
          contract_date: "2024-08-01",
          claim_date: "2024-12-15",
          submit_claim_time: "110",
          match: false,
        },
      },
    },
  ];

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const brandColor = useColorModeValue("brand.500", "white");

  function columnToKeepForTable(originalcolumnsname) {
    const columnsToKeep = [
      // "PREVIEW", // removed per request
      "CPT_CODE",
      "Provider_Name",
      "Date",
      "DESCRIPTION",
      "RATE",
      "TAX_ID",
      "report",
    ];
    const filteredColumns = originalcolumnsname.filter((columnName) =>
      columnsToKeep.includes(columnName)
    );

    return filteredColumns;
  }

  function tableDataToKeepForTable(tableData) {
    const columnsToKeep = [
      // "PREVIEW",
      "CPT_CODE",
      "Provider_Name",
      "Date",
      "DESCRIPTION",
      "RATE",
      "TAX_ID",
      "report",
    ];
    const filteredListOfObjects = tableData.map((obj) => {
      const filteredObj = {};
      columnsToKeep.forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          filteredObj[key] = obj[key];
        }
      });
      return filteredObj;
    });

    return filteredListOfObjects;
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <Box>
            <SidebarContext.Provider>
              <Sidebar />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={{ base: "100%", xl: "calc( 100% - 290px )" }}
                maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routes)}
                      secondary={getActiveNavbar(routes)}
                      message={getActiveNavbarText(routes)}
                      fixed={false}
                      handleDownloadFileClick={handleDownloadFileClick}
                      handleBigQueryClick={handleBigQueryClick}
                      // {...rest}
                    />
                  </Box>
                </Portal>
                <Box
                  mx="auto"
                  p={{ base: "20px", md: "30px" }}
                  pe="20px"
                  minH="100vh"
                  pt="50px"
                >
                  <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                    <>
                      {loading ? (
                        <Loader />
                      ) : (
                        <>
                          <Card
                            direction="column"
                            w="100%"
                            px="0px"
                            overflowX={{ sm: "scroll", lg: "hidden" }}
                            pb="0px"
                          >
                            <div className="w-full h-[90%] px-5 relative overflow-x-auto shadow-md sm:rounded-lg">
                              <Table
                                variant="simple"
                                color="gray.500"
                                mb="24px"
                              >
                                <Thead>
                                  <Tr>
                                    {columnToKeepForTable(columnNames).map(
                                      (columnName, index) => (
                                        <Th pe="10px" borderColor={borderColor}>
                                          {columnName === "Date"
                                            ? "DATE OF SERVICE"
                                            : convertString(columnName)}
                                        </Th>
                                      )
                                    )}
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {tableDataToKeepForTable(tableData).map(
                                    (row, rowIndex) => (
                                      <Tr>
                                        {columnToKeepForTable(columnNames).map(
                                          (columnName, colIndex) => (
                                            <Td key={colIndex}>
                                              {columnName === "report" ? (
                                                <button
                                                  type="button"
                                                  data-dropdown-toggle="notification-dropdown"
                                                  class="p-2 text-button-color rounded-lg hover:text-gray-900 hover:bg-gray-100 "
                                                  onClick={() => {
                                                    setReportPreview(
                                                      findMatchingReport(row)
                                                    );
                                                    setShowreportPreview(true);
                                                  }}
                                                >
                                                  <span class="sr-only">
                                                    View notifications
                                                  </span>
                                                  {(() => {
                                                    const matchedReport =
                                                      findMatchingReport(row);
                                                    const isSuccess =
                                                      checkSuccess(
                                                        matchedReport
                                                      );

                                                    return (
                                                      <>
                                                        {isSuccess ? (
                                                          <Flex align="center">
                                                            <Icon
                                                              w="24px"
                                                              h="24px"
                                                              me="5px"
                                                              color="green.500"
                                                              as={MdCheckCircle}
                                                            />
                                                            <Text
                                                              color={textColor}
                                                              fontSize="sm"
                                                              fontWeight="700"
                                                            >
                                                              Approved
                                                            </Text>
                                                          </Flex>
                                                        ) : (
                                                          <Flex align="center">
                                                            <Icon
                                                              w="24px"
                                                              h="24px"
                                                              me="5px"
                                                              color="red.500"
                                                              as={MdCancel}
                                                            />
                                                            <Text
                                                              color={textColor}
                                                              fontSize="sm"
                                                              fontWeight="700"
                                                            >
                                                              Rejected
                                                            </Text>
                                                          </Flex>
                                                        )}
                                                      </>
                                                    );
                                                  })()}
                                                </button>
                                              ) : (
                                                <Text
                                                  color={textColor}
                                                  fontSize="sm"
                                                  fontWeight="700"
                                                >
                                                  {columnName === "CPT_CODE" ||
                                                  columnName ===
                                                    "Provider_Name" ||
                                                  columnName === "Date" ||
                                                  columnName ===
                                                    "DESCRIPTION" ||
                                                  columnName === "RATE" ||
                                                  columnName === "TAX_ID" ||
                                                  columnName === "report"
                                                    ? row[columnName]
                                                    : ""}
                                                </Text>
                                              )}
                                            </Td>
                                          )
                                        )}
                                      </Tr>
                                    )
                                  )}
                                </Tbody>
                              </Table>
                            </div>
                          </Card>
                          {reportPreview === null ? (
                            <></>
                          ) : (
                            showreportPreview && (
                              <ReportModal
                                showreportPreview={showreportPreview}
                                setShowreportPreview={setShowreportPreview}
                                reportPreview={reportPreview}
                              />
                            )
                          )}
                        </>
                      )}
                    </>
                  </Box>
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </Box>
      )}
      <BigQueryModal
        openModal={openModal}
        modalLoading={modalLoading}
        handleFormSubmit={handleFormSubmit}
        setOpenModal={setOpenModal}
        selectedDataset={selectedDataset}
        datasets={datasets}
        setSelectedDataset={setSelectedDataset}
        setTableLoading={setTableLoading}
        setTables={setTables}
        selectedTable={selectedTable}
        tableLoading={tableLoading}
        tables={tables}
        setSelectedTable={setSelectedTable}
      />
    </>
  );
}
